const config = {
    mapsKey: 'AIzaSyAG8A41MD4E9vdCzG5vPZNi-TQAn0Wia9E',
}

export default config;

